import * as React from "react";
const SvgSquareList = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.16683 6.66659L13.3335 6.66703M9.16683 9.99992L13.3335 10.0003M9.16683 13.3333L13.3335 13.3337M6.66683 13.3333H6.67516M6.66683 9.99992H6.67516M6.66683 6.66659H6.67516M7.3335 16.6666H12.6668C14.067 16.6666 14.767 16.6666 15.3018 16.3941C15.7722 16.1544 16.1547 15.772 16.3943 15.3016C16.6668 14.7668 16.6668 14.0667 16.6668 12.6666V7.33325C16.6668 5.93312 16.6668 5.23306 16.3943 4.69828C16.1547 4.22787 15.7722 3.84542 15.3018 3.60574C14.767 3.33325 14.067 3.33325 12.6668 3.33325H7.3335C5.93336 3.33325 5.2333 3.33325 4.69852 3.60574C4.22811 3.84542 3.84566 4.22787 3.60598 4.69828C3.3335 5.23306 3.3335 5.93312 3.3335 7.33325V12.6666C3.3335 14.0667 3.3335 14.7668 3.60598 15.3016C3.84566 15.772 4.22811 16.1544 4.69852 16.3941C5.2333 16.6666 5.93336 16.6666 7.3335 16.6666Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgSquareList;
